// API END Points
import * as constants from '../utils/constants';
/**---------------Authentication------------------------------ */
export const AddFeedback = 'feedback' + ' ' + constants.POST_RAW;
